// extracted by mini-css-extract-plugin
export default {"overlay":"styles_overlay__bQx+T","image":"styles_image__miEW1"};